import {CircularProgress, Container, Stack} from '@mui/material';
import type * as React from 'react';
import SignInForm from '@/components/Forms/SignInForm';
import Header from '@/components/Header';
import {useUserContext} from '@/components/Providers/UserContext';
import MyRentals from '@/pages/MyRentals';

const Home = () : React.ReactElement => {
    const {user} = useUserContext();

    if (user === undefined) {
        return <Container sx={{height: '100%'}}>
            <Container sx={{mt: '125px'}}>
                <CircularProgress/>
            </Container>
        </Container>;
    }

    if (user === null) {
        return <Stack
            direction='column'
            sx={{
                backgroundColor: '#631d79',
                height: '100%',
            }}
        >
            <Header/>
            <Container sx={{mt: '125px'}}>
                <SignInForm/>
            </Container>
        </Stack>;
    }

    return <MyRentals/>;
};

export default Home;
